export const defaultSelectionLimit = 8;
export const defaultCustomQuestionsSelectionLimit = 0;
